module.exports = __webpack_public_path__ + "img/打印机.e0436ac6.png";